import React from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

const Timer = (props) => {
    const { profit, countdownText } = props;

  return (
    <div>
        <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
        <Typography>Profit:</Typography>
        <Typography sx={{color: 'primary.success', marginLeft: '8px'}}>${profit}</Typography>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'space-evenly', marginTop: '4px'}}>
        <Typography>Matures in:</Typography>
        <Typography sx={{color: 'primary.warning', marginLeft: '8px'}}>{countdownText}</Typography>
        </Box>
    </div>
  )
}

export default Timer
